import React from 'react'
// import { Icon } from 'loyal-react'
import '@loyal_template/tracking.css'
import PropTypes from 'prop-types'
// import moment from 'moment'
import { Status } from '../../../../App/Header/Tracking/Item/Status'

const TrackingItem = props => {
  return props.tracking && props.tracking.statuses ? (
    <div className='order-tracking col-12 px-0 pb-1'>
      <div className='row mx-0 align-items-center h-100'>
        <div className='col-12 pb-3 px-0'>
          <h3 className='color-ui-2 txt-uppercase txt-body txt-circular-black'>
            DETALHE DO RASTREAMENTO
          </h3>
        </div>
        <ul className='tracking-steps col-12 px-0'>
          {props.tracking.statuses.map((track, index) => (
            <Status status={track} index={index} />
          ))}
        </ul>
      </div>
    </div>
  ) : (
    ''
  )
}

TrackingItem.propTypes = {
  tracking: PropTypes.array
}

export default TrackingItem



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductSide/TrackingItem.js